// UI Component Imports
import { CustomButton } from "@/components/ui/Buttons";

// Icon Imports
import CompanyIcon from "@/assets/icons/Company.svg";
import CategoryIcon from "@/assets/icons/Category.svg";
import CalenderIcon from "@/assets/icons/CalenderGrayClock.svg";
import VideoIcon from "@/assets/icons/VideoPauseIcon.svg";
import InfoIcon from "@/assets/icons/InfoIcon.svg";
import Clock from "@/assets/icons/ClockIcon.svg";
import ClockDeadline from "@/assets/icons/ClockDeadline.svg";
import ProductIcon from "@/assets/icons/Product.svg";
import InfoIconBlack from "@/assets/icons/InfoIconBlack.svg";
import LedProject from "@/assets/icons/LedProject.svg";
import PassionbitsAssuredLogo from "@/assets/logo/PassionbitsAssuredLogo.svg";
import CreatorCanvas from "@/assets/icons/CreatorCanvas.svg";
import MultiActorIcon from "@/assets/icons/multiActorIcon.svg";

// Redux Imports
import { useAppSelector } from "@/redux/hooks/hooks";
import { TJob, TOrderVideo } from "@/redux/feature/jobs/jobsType";
import {
  AcceptJobPayload,
  // useAcceptJobMutation,
  useApplyToJob2Mutation,
} from "@/redux/feature/jobs/jobsApi";

// Utility Imports
import { handleApiRequest } from "@/utils/handleApiRequest";
import { formatDate } from "@/utils/formateData";
import moment from "moment";
import toast from "react-hot-toast";

// Constants
import { Dispatch, SetStateAction, useState } from "react";
import { useGetMeQuery } from "@/redux/feature/user/userApi";
import { useGlobalContext } from "@/context/GlobalContext";
import Modal from "@/components/ui/Modal";
import { DefaultCompanyLogo } from "@/constant";
import { TUCDT } from "@/hooks/useCurrencyByLocation";
import AssembleCastModal from "./AssembleCastModal";

type TProjectConfirmModal = {
  setOpen: Dispatch<SetStateAction<boolean>>;
  onClick: (vl: string) => void;
  isLoading: boolean;
};

const ProjectConfirmModalHomeStudio = ({
  setOpen,
  onClick,
  isLoading,
}: TProjectConfirmModal) => {
  return (
    <div>
      <div className="flex items-center gap-x-3">
        <div>
          <LedProject />
        </div>
        <p className="text-[#000000] text-sm leading-5 tracking-[0%] font-semibold">
          Home Studio Project
        </p>
      </div>
      <p className="text-[#475467] text-base leading-[30px] tracking-[0%] mt-6">
        This project is classified as "
        <span className="italic font-medium">Home Studio Project,</span>"
        meaning{" "}
        <span className="underline underline-offset-4">
          you are only responsible for providing{" "}
          <span className="font-semibold">high-quality raw footage</span> and
          maintaining the required{" "}
          <span className="font-semibold">recording setup</span>.
        </span>
      </p>

      <p className="mt-5 text-[#475467] text-base leading-[30px] tracking-[0%]">
        Our internal team will handle the editing and post-production. Please
        confirm that you are comfortable with these requirements.
      </p>

      <div className="flex flex-col md:flex-row w-full gap-4 mt-6">
        <CustomButton
          onClick={() => setOpen(false)}
          variant="outline"
          color="#344054"
          fontSize="14px"
          fontWeight="500"
          padding="10px 24px"
          border="1px solid #E8EBEE"
          borderRadius="8px"
          className="leading-5 w-full"
        >
          No, I want to reconsider
        </CustomButton>
        <CustomButton
          fontSize="14px"
          onClick={() => onClick("shoot_only")}
          fontWeight="500"
          disabled={isLoading}
          padding="10px 24px"
          backgroundColor="#17457D"
          borderRadius="8px"
          className="leading-5 w-full"
        >
          {isLoading ? "Loading" : "Yes, I’m in"}
        </CustomButton>
      </div>
    </div>
  );
};

export default ProjectConfirmModalHomeStudio;

const FulfilledBadge = () => {
  return (
    <div
      className="whitespace-nowrap rounded-full bg-white p-0 overflow-hidden border-[1.3px] border-transparent"
      style={{
        backgroundImage:
          "linear-gradient(white, white), linear-gradient(to right, #FF6600, #5481D8)",
        backgroundOrigin: "border-box",
        backgroundClip: "content-box, border-box",
      }}
    >
      <div className="px-3">
        <span className="text-sm font-semibold italic text-orange-600">
          Fulfilled by Creator
        </span>
      </div>
    </div>
  );
};
